import React from "react";
import {
    GoogleMap,
    useJsApiLoader,
    MarkerF,
} from "@react-google-maps/api";
import CustomModal from "../custom-modal";
import { DeliveryPoint } from "../checkout/checkout-sacrifices/choose-delivery-point";
import LoadingSpinner from "../loading-spinner";
import { CloseIcon } from "../../assets/icons";

const mapContainerStyle: React.CSSProperties = {
    width: "100%",
    height: "500px",
};

interface DeliveryPointMapProps {
    isOpen: boolean;
    onClose: () => void;
    point: DeliveryPoint | null;
}

const DeliveryPointMap = ({ isOpen, onClose, point }: DeliveryPointMapProps) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyBCLsDYm5wpEwzYA2jXRr5Rrs-dJFvLFVg",
        libraries: ["places"],
    });

    if (!point) return null;

    const center = {
        lat: parseFloat(point.lat),
        lng: parseFloat(point.lng),
    };

    return (
        <CustomModal isOpen={isOpen} setIsOpen={onClose} maxWidth="!max-w-[800px] bg-white rounded-2xl overflow-hidden">
            <div className="flex flex-col">
                <div className="flex items-center justify-between p-4 border-b">
                    <h3 className="text-xl font-semibold">{point.name}</h3>
                    <button onClick={onClose} className="hover:scale-110 transition">
                        <CloseIcon />
                    </button>
                </div>
                <div className="p-4">
                    <p className="mb-4 text-gray-600">{point.address}</p>
                    {isLoaded ? (
                        <div className="rounded-xl overflow-hidden border">
                            <GoogleMap
                                mapContainerStyle={mapContainerStyle}
                                zoom={15}
                                center={center}
                                options={{
                                    disableDefaultUI: false,
                                    mapTypeControl: false,
                                    streetViewControl: false,
                                }}
                            >
                                <MarkerF
                                    position={center}
                                    icon="/zabehatyIcons/map-pointer.svg"
                                />
                            </GoogleMap>
                        </div>
                    ) : (
                        <div className="h-[500px] flex items-center justify-center">
                            <LoadingSpinner />
                        </div>
                    )}
                </div>
            </div>
        </CustomModal>
    );
};

export default DeliveryPointMap;
